import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { ChevronRight, Sparkles, ArrowRight } from "lucide-react";

// Import des styles Swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { NavLink } from "../../ui/NavLink";
import { useAuth, useFeaturedCategories, useShops } from "@cabukaka/hooks";

const Hero = () => {
  const { user } = useAuth();
  const isLoggedIn = !!user;
  const { shops: featuredShops } = useShops();
  const { featuredCategories } = useFeaturedCategories();

  return (
    <section className="bg-gray-100 py-4 px-3 md:px-6 max-w-[1400px] mx-auto overflow-hidden">
      {/* Hauteur réduite : 200px sur mobile, 320px sur desktop */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 h-[200px] md:h-[320px]">
        
        {/* ==================== 1. MENU LATÉRAL (Ajusté) ==================== */}
        <div className="hidden lg:flex flex-col bg-white rounded-2xl p-4 shadow-sm border border-gray-200/60 justify-between">
          <div>
            <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 px-2 flex items-center gap-2">
              <Sparkles className="w-3.5 h-3.5 text-primary" /> Nos Rayons
            </h2>
            <nav className="space-y-0.5">
              {featuredCategories.slice(0, 6).map((cat) => (
                <NavLink
                  key={cat.slug}
                  to={`/categories/${cat.slug}`}
                  className="flex items-center justify-between px-2.5 py-1.5 text-sm text-gray-700 hover:bg-primary/5 hover:text-primary rounded-xl font-medium transition-colors"
                >
                  <span className="truncate">{cat.name}</span>
                  <ChevronRight className="w-3.5 h-3.5" />
                </NavLink>
              ))}
            </nav>
          </div>
        </div>

        {/* ==================== 2. SWIPER CENTRAL ==================== */}
        <div className="col-span-1 lg:col-span-2 relative rounded-2xl overflow-hidden shadow-md bg-slate-500 group">
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            className="h-full w-full"
          >
            {featuredShops.map((shop) => (
              <SwiperSlide key={shop.id} className="relative w-full h-full">
                <img
                  src={shop.coverImage}
                  alt={shop.name}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/20 to-transparent" />
                
                <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-10 text-white z-10">
                  <h3 className="text-xl md:text-3xl font-extrabold mb-1 drop-shadow-md">
                    {shop.name}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-200 mb-4 font-medium max-w-sm truncate">
                    {shop.location.address}
                  </p>
                  <NavLink
                    to={`/boutiques/${shop.id}`}
                    className="bg-primary text-white font-semibold text-xs px-5 py-2 rounded-xl shadow-lg hover:bg-primary/90 transition-all w-fit"
                  >
                    Visiter la boutique
                  </NavLink>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* ==================== 3. PANNEAU DROITE (Ajusté) ==================== */}
        <div className="hidden lg:flex flex-col">
          <div className="flex-1 bg-white rounded-2xl p-4 shadow-sm border border-gray-200/60 flex flex-col justify-center items-center text-center">
            <div className="w-12 h-12 bg-gray-50 rounded-full border border-gray-100 flex items-center justify-center mb-2">
              <span className="text-xl">👋</span>
            </div>
            <p className="text-sm font-medium text-gray-500">
              {isLoggedIn ? "Bon retour !" : "Bienvenue !"}
            </p>
            <p className="text-sm font-bold text-gray-800 mb-4 truncate w-full">
              {isLoggedIn ? user?.username : "Prêt à commander ?"}
            </p>
            {!isLoggedIn && (
              <div className="flex flex-col gap-2 w-full">
                <NavLink to="/auth/register" className="bg-primary text-white text-xs font-semibold py-2 rounded-xl text-center hover:bg-primary/90">S'inscrire</NavLink>
                <NavLink to="/auth/login" className="bg-gray-100 text-gray-700 text-xs font-semibold py-2 rounded-xl text-center hover:bg-gray-200">Connexion</NavLink>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;